<template>
  <svg-vue
    v-tooltip="{
      content: 'We’re verifying this action in the background to make sure it’s completed correctly. Some checks finish quickly, while others may take longer, depending on the action. We’ll notify you if we encounter any issues.',
      placement: 'bottom',
      theme: 'dark-blue-tooltip',
    }"
    icon="icons/pending-clock"
    class="tw-w-6 tw-cursor-pointer"
  />
</template>

